import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useUser } from '../context/UserContext';
import { userHasIneOnFile } from '../utils/normalizeUser';
import { UPLOAD_INE_PATH, WELCOME_PATH } from './routePaths';

/**
 * Layout route that protects child routes. If the user is not authenticated,
 * redirects to the welcome page. If authenticated but INE not uploaded,
 * redirects to the INE upload step (except when already on that page).
 */
function PrivateRoute(): React.ReactElement {
  const { isAuthenticated, isInitialized, user } = useUser();
  const location = useLocation();
  const isOnUploadIne = location.pathname === UPLOAD_INE_PATH;

  if (!isInitialized) {
    return <CircularProgress />;
  }

  if (!isAuthenticated) {
    return <Navigate to={WELCOME_PATH} replace />;
  }

  if (user && !user.isAdmin && !userHasIneOnFile(user) && !isOnUploadIne) {
    return <Navigate to={UPLOAD_INE_PATH} replace />;
  }

  return <Outlet />;
}

export default PrivateRoute;
